import React, { useEffect } from "react";
import banner from "../../../../assets/Banners/banner_netuno-gracias.png";
import ButtonGeneric from "../../../../components/Buttons/ButtonGeneric";
import { UseContextApp } from "../../../../Global/Context/appContext";
import { PaperClipIcon, CreditCardIcon } from '@heroicons/react/solid'
import StepsGeneric from "../../../../components/Nav/StepsGeneric";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function BanescoConfirmationFailed() {
    const navigate = useNavigate();
    const [{ user }] = UseContextApp()
    const atras = () => {navigate('/cuenta/pagos')}
    return (
        <div className=" relative bg-[#f3f4f6]">
            <div className="flex max-w-7xl mx-auto  pt-6 justify-center">
                <div className="flex w-full lg:w-full px-4 pt-5 gap-5 flex-col">
                    <div className="bg-white  rounded-md shadow">

                    </div>
                    <div className="bg-white  rounded-md shadow mb-[100px]">
                        <div className=" flex justify-center items-center flex-col gap-6 ">
                            <div className="w-full flex-col flex gap-5">
                                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                                    <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                                        <div className="ml-4 mt-4">
                                            <h3 className="text-2xl leading-6 font-medium text-gray-900">
                                                Confirmación
                                            </h3>
                                            <p className="mt-1 text-sm text-gray-500">Confirmación de pago</p>
                                        </div>
                                    </div>
                                </div>
                                <main className="bg-white px-4  md:pb-0 sm:px-6 sm:pt-24 md:px-0 md:py-0">
                                    <div className="pl-5 flex flex-col gap-4 mx-auto">
                                        <div className="w-full flex justify-center items-center rounded-md  pt-5">
                                            <img className="w-[50%] object-contain h-[400px] " src={banner} alt="" />
                                        </div>
                                        <div className="grid place-content-center pla">
                                            <div className="max-w-xl flex flex-col justify-center ">
                                                <p className="mt-2 text-center text-2xl md:text-4xl font-extrabold tracking-tight sm:text-5xl">
                                                    Pago No Exitoso
                                                </p>
                                                <dl className=" text-center mt-6 md:mt-0 text-sm font-medium">
                                                    Su pago fue rechazado por el banco. Intente realizar su transacción más tarde, de continuar con el inconveniente, por favor comuníquese con su entidad financiera.
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                                <div className="w-full flex justify-center   gap-[50%] p-5 ">
                                    <div className="w-[47%] flex justify-between gap-[30px] ml-[20px] ">
                                        <ButtonGeneric funtion={atras} text={"Volver"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default BanescoConfirmationFailed;
